var voted_users_rtlignore_default = {
  "container": "JwgM3",
  "webview": "QLS8j",
  "avatar_list": "iEKcO",
  "avatar": "YOS0C",
  "user_avatar": "_4Rd1U",
  "modal": "QxYGX",
  "voted_users_modal": "PHqf2",
  "overlay": "uI7zj",
  "user_card": "DEdYd",
  "user_name": "nkJ-X",
  "voted_users_modal_header": "uxtSk",
  "cta": "oMGlL",
  "close_icon": "bAQ3Q",
  "title": "i7u9o",
  "member_list_container": "PGG8K",
  "member_list": "bqmlj",
  "loader": "lbTg2",
  "anonymous_counter": "ppnY7",
  "spinner": "_3ZPTO",
  "spin": "a-PLR"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
